<!-- 二维码分享 -->
<template>
  <div class="share-way">
    <div class="share-way-warp">
      <div class="title" :class="{'isTitleH2':isTitleH2}">{{title}}</div>
      <div class="share-way-con">
        <div class="share-way-left">
          <img :src="qrcodeUrl" />
        </div>
        <div class="share-way-right column-flex">
          <div class="share-addr">
            <div class="input-group">
              <el-input v-model="shareAddr" id="shareInput"></el-input>
              <el-button @click="handleCopyUrl">复制</el-button>
            </div>
            <el-button @click="handleOpenUrl"> 打开 </el-button>
          </div>
          <div class="linkbox">
            <a
              :href="qrcodeSmall"
              target="_blank"
              download="event"
              class="qrcodeLink"
              title="下载256*256"
            >
              256*256
            </a>
            <a
              :href="qrcodeMid"
              target="_blank"
              download="event"
              class="qrcodeLink"
              title="下载512*512"
            >
              512*512
            </a>
            <a
              :href="qrcodeBig"
              target="_blank"
              download="event"
              class="qrcodeLink"
              title="下载1024*1024"
            >
              1024*1024
            </a>
            <a
              :href="qrcodeSL"
              target="_blank"
              download="event"
              class="qrcodeLink"
              title="下载矢量图"
            >
              矢量图
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DOMAIN } from "@/utils/api";
import { MSG } from "@/utils/utils";

export default {
  name: "share-way",
  data() {
    return {
      qrcodeUrl: "",
      qrcodeSmall: "",
      qrcodeMid: "",
      qrcodeBig: "",
      qrcodeSL: "",
      shareAddr: "",
      qrcode: `${DOMAIN}/survey/qrcode`,
    };
  },
  computed: {
    ...mapGetters(["shareSurvey"]),
  },
  props: {
    title: {
      type: String,
      default: '问卷分享',
    },
    isTitleH2: {
      type: Boolean,
      default: false,
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.handleShare();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    handleShare() {
      if (!this.shareSurvey) {
        console.log("参数异常");
        return;
      }
      let { id, url, hash, status } = this.shareSurvey;
      this.shareAddr = url;
      let _url = `${this.qrcode}?surveyId=${id}&hash=${hash}&type=`;
      // _url =
      //   "https://survey.58corp.com/survey/qrcode?surveyId=1023011&hash=h1eq&type=";
      this.qrcodeUrl = _url + 1;
      this.qrcodeSmall = _url + 1;
      this.qrcodeMid = _url + 2;
      this.qrcodeBig = _url + 3;
      this.qrcodeSL = _url + 4;
    },
    handleOpenUrl() {
      window.open(this.shareAddr);
    },
    handleCopyUrl() {
      const range = document.createRange();
      range.selectNode(document.getElementById("shareInput"));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      MSG.success("已复制");
    },
  },
};
</script>
<style lang='scss' scoped>
.share-way {
  .share-way-warp {
    max-width: 660px;
    margin: 0 auto;
  }
  .share-way-con {
    display: flex;
  }
  .title {
    margin-bottom: 10px;
    color: #181818;
  }
  .isTitleH2{
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .share-way-left {
    margin-right: auto;
    height: 110px;
    img {
      width: 110px;
      height: 100%;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      box-shadow: 0px 6px 6px -6px rgba(0, 0, 0, 0.1);
    }
  }
  .share-way-right {
    flex: 1;
    padding-left: 20px;
    justify-content: space-between;
    .el-input {
      margin-right: 20px;
      width: 330px;
    }
    .linkbox {
      display: flex;
      a {
        height: 44px;
        line-height: 44px;
        text-align: center;
        padding: 0 15px;
        background-color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 4px;
        color: #333;
        box-shadow: 0px 6px 6px -6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        &:hover {
          color: #58a6e7;
        }
      }
      a + a {
        margin-left: 10px;
      }
    }
  }
  .share-addr {
    display: flex;
    .el-button {
      width: 74px;
      height: 44px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(245, 245, 245, 1);
      color: #333;
      &:hover {
        color: #58a6e7;
      }
    }
    .input-group {
      position: relative;
      width: 436px;
      height: 44px;
      border: 1px solid rgba(238, 238, 238, 1);
      background-color: rgba(249, 249, 249, 1);
      border-radius: 4px;
      box-shadow: 0px 6px 6px -6px rgba(0, 0, 0, 0.1);
      margin-right: 10px;
      .el-input {
        width: 100%;
        /deep/ .el-input__inner {
          padding: 0 90px 0 15px;
          border: none;
          background-color: rgba(249, 249, 249, 1);
          color: #333;
        }
      }
      .el-button {
        height: 42px;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 0 4px 4px 0;
        border-right: none;
        border-top: none;
        border-bottom: none;
      }
    }
  }
  .info {
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shareCommon/share-qrcode.vue